import React, { useEffect, useState } from 'react';

const Question4 = ({ response, setSubmitDisabled, question, handleResponse }) => {

  const [selectedResponse, setSelectedResponse] = useState(response);

  const handleChange = (event) => {
    const value = event.target.value === 'true';
    setSelectedResponse(value);
    handleResponse(3, value);
  };

  const renderMessageBox = () => {
    if (selectedResponse === true) {
      return (
        <div className="message-box">
          <div>
            <i className="fas fa-info-circle blue"></i>
          </div>
          <div className='message-content'>
            <p>Study Design Identified: <strong>{question.name}</strong></p>
            <br />
            <p>Requirements:</p>
            <div className='requirement-item'>
              <div><i className="fas fa-check blue"></i></div>
              <p dangerouslySetInnerHTML={{__html: question.message_html}}></p>
            </div>
            <div className='requirement-item'>
              <div><i className="fas fa-check blue"></i></div>
              <div className='clinical-trial-container'>
                <p><strong>Clinical trial registration </strong> required before publication.</p>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  const renderProspectiveRadioButtons = () => {
    return (
      <div className='question-block'>
        <h5>{question.question_text}</h5>
        <input
          type="radio"
          name="prospective"
          value="false"
          onChange={handleChange}
          checked={selectedResponse === false}
          id="prospective_false"
        />
        <label htmlFor="prospective_false">{question.false_response_text}</label>
        <br />
        <input
          type="radio"
          name="prospective"
          value="true"
          onChange={handleChange}
          checked={selectedResponse === true}
          id="prospective_true"
        />
        <label htmlFor="prospective_true">{question.true_response_text}</label>
        <br />
        {renderMessageBox()}
      </div>
    );
  };

  return (
    <div>
      {renderProspectiveRadioButtons()}
    </div>
  );
};

export default Question4;